angular.module("ainapp")
    .controller("recipeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Recipe";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Units = [];
            MainService.UnitsInDropdown().then(function (response) {
                $scope.Units = response.data;

            })


            $scope.Init = function () {
                $scope.Recipe = {
                    ProductId: $stateParams.productId,
                    RProductId: "",
                    RUnitId: "",
                    RQuantity: 0,
                    Rate: 0,
                }

                $scope.load = false;
                $scope.RecipeList = [];
            }
            $scope.Init();

            $scope.ProductAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.productInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.RProductAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Recipe.RProduct = {};
                    $scope.Recipe.RProduct.Name = data.Name;
                    $scope.Recipe.RProduct.ProductCode = data.ProductCode;
                    $scope.Recipe.RProduct.Id = data.Id;
                    $scope.Recipe.RProductId = data.Id;
                    $scope.Recipe.RUnitId = data.UnitId;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };

            $scope.RProductCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "ProductCode",
                dataTextField: "ProductCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Recipe.RProduct = {};
                    $scope.Recipe.RProduct.Name = data.Name;
                    $scope.Recipe.RProduct.ProductCode = data.ProductCode;
                    $scope.Recipe.RProduct.Id = data.Id;
                    $scope.Recipe.RProductId = data.Id;
                    $scope.Recipe.RUnitId = data.UnitId;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.ProductId = $stateParams.productId;
                        MainService.RecipesInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "RProduct.Name": {
                                type: "string",
                                editable: false,
                            },
                            "RUnit.Name": {
                                type: "string",
                                editable: false,
                            },
                            Rate: {
                                type: "number",
                                editable: false,
                            },
                            RQuantity: {
                                type: "number",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [
                    {
                        field: "RProduct.Name",
                        title: "Product",
                        },
                    {
                        field: "RUnit.Name",
                        title: "Unit",
                        },
                    {
                        field: "RQuantity",
                        title: "Quantity",
                        },
                    {
                        field: "Rate",
                        title: "Rate",
                        },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }


            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteRecipe($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {
                $scope.Recipe = data;
            }


            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.Recipe.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.Recipe.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");

                } else if ($scope.Recipe.ProductId == "") {
                    toastr.warning("Select Product");

                } else if ($scope.Recipe.RProductId == "") {
                    toastr.warning("Select Recipe Product");
                } else if ($scope.Recipe.RUnitId == "") {
                    toastr.warning("Select Unit");
                } else if ($scope.Recipe.RQuantity <= 0) {
                    toastr.warning("Enter Quantity");

                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddRecipe($scope.Recipe).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.Init();
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            $scope.load = false;
                        } else {
                            toastr.error("Error");
                            $scope.load = false;
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }

                }])
